import React from "react";
import {Row, Col, Button} from "react-bootstrap";
import {translate} from "../../i18n/translate.js";
import {Modal} from 'react-bootstrap';
import LoginInputField from "../../components/login/LoginInputField";
import {URLs} from "../../common/constants";

class LoginForgetPassword extends React.Component {
    state = {
        email: this.props.email,
        password: ''
    };

    handleChangeEmail = (value) => {
        this.setState({email: value});
    };

    backToSignInClicked = () => {
        this.props.resetEmailSent();
    };

    emailSubmitClicked = () => {
        this.props.forgetPassword(this.state.email);
    };

    render() {
        const component = (this.props.loginStatus || {}).component;
        const status = (this.props.loginStatus || {}).status;
        let className = "border-container";
        if (URLs.JOIN === this.props.flowType) {
            className += " border-container-join";
        }
        const styleTitle = URLs.JOIN === this.props.flowType && this.props.clientViewPort.isXs ? "forget-password-title" : "log-in-title-row";
        return (<div className={className}>
            <fieldset className="inner-container forgot-password-container" disabled={this.props.showLoading}>
                <div className="form-container container-fluid">
                    <Row className={styleTitle}>
                        {
                            URLs.JOIN === this.props.flowType ? undefined :
                                <i className="back-sign-in-arrow hidden-sm hidden-md hidden-lg"
                                   onClick={this.backToSignInClicked}/>
                        }
                        <div className="log-in-title">{translate('Forgot Password')}</div>
                    </Row>
                    <Row>
                        <div className="reset-password-text">To reset your password, enter your email address and we'll
                            send you instructions on how to
                            create a new password.
                        </div>
                    </Row>
                    <LoginInputField type="email" placeholder="Email" value={this.state.email} label="email" ref="email"
                                     error={component === 'email' ? status : undefined} update={this.handleChangeEmail}
                                     fieldName="email"/>
                    <Row className="email-log-in">
                        <Button bsStyle="primary" className={"button email-login-button" + (this.props.showLoading ? " loading" : "")} onClick={this.emailSubmitClicked}>
                            <div className="btn-email-text">{translate('Submit')}</div>
                        </Button>
                        {
                            this.props.clientViewPort.isXs && this.props.flowType === URLs.JOIN
                            && this.props.loginStatus.isResetPasswordEmailSent ?

                                <div className="email-sent-message mobile-login-forget-password-text">
                                    <div className="email-sent-message-text">We just emailed you a link you can use
                                        to reset your password.
                                    </div>
                                </div>
                                : undefined
                        }
                    </Row>
                    {
                        this.props.clientViewPort.isXs ? undefined :
                            <Row className="forget-password-row">
                                <a className="back-sign-in"
                                onClick={this.backToSignInClicked}>{translate('Back to Login')}</a>
                            </Row>
                    }
                </div>
                {
                    this.props.clientViewPort.isXs && this.props.flowType === URLs.JOIN ? undefined :
                        <div className="bottom-container">
                            {
                                this.props.loginStatus.isResetPasswordEmailSent ?

                                    <div className="email-sent-message">
                                        <div className="email-sent-message-text">We just emailed you a link you can use
                                            to reset your password.
                                        </div>
                                    </div>
                                    : undefined
                            }
                        </div>
                }
            </fieldset>
        </div>);
    }
}

export default LoginForgetPassword;





// WEBPACK FOOTER //
// ./src/components/login/LoginForgetPassword.js